/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { MDIBaseService } from '../mdi-base-service';
import { MDIApiConfiguration } from '../mdi-api-configuration';
import { MDIStrictHttpResponse } from '../mdi-strict-http-response';

import { productBenefitGetAllProductBenefitsGet } from '../fn/product-benefit/product-benefit-get-all-product-benefits-get';
import { ProductBenefitGetAllProductBenefitsGet$Params } from '../fn/product-benefit/product-benefit-get-all-product-benefits-get';
import { ProductBenefitModel } from '../models/product-benefit-model';
import { ProductBenefitModelSearchResultModel } from '../models/product-benefit-model-search-result-model';
import { productBenefitPost } from '../fn/product-benefit/product-benefit-post';
import { ProductBenefitPost$Params } from '../fn/product-benefit/product-benefit-post';
import { productBenefitSearchProductBenefitPost } from '../fn/product-benefit/product-benefit-search-product-benefit-post';
import { ProductBenefitSearchProductBenefitPost$Params } from '../fn/product-benefit/product-benefit-search-product-benefit-post';

@Injectable({ providedIn: 'root' })
export class MDIProductBenefitService extends MDIBaseService {
  constructor(config: MDIApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `productBenefitSearchProductBenefitPost()` */
  static readonly ProductBenefitSearchProductBenefitPostPath = '/ProductBenefit/SearchProductBenefit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productBenefitSearchProductBenefitPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  productBenefitSearchProductBenefitPost$Response(params?: ProductBenefitSearchProductBenefitPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<ProductBenefitModelSearchResultModel>> {
    return productBenefitSearchProductBenefitPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productBenefitSearchProductBenefitPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  productBenefitSearchProductBenefitPost(params?: ProductBenefitSearchProductBenefitPost$Params, context?: HttpContext): Observable<ProductBenefitModelSearchResultModel> {
    return this.productBenefitSearchProductBenefitPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<ProductBenefitModelSearchResultModel>): ProductBenefitModelSearchResultModel => r.body)
    );
  }

  /** Path part for operation `productBenefitGetAllProductBenefitsGet()` */
  static readonly ProductBenefitGetAllProductBenefitsGetPath = '/ProductBenefit/GetAllProductBenefits';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productBenefitGetAllProductBenefitsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  productBenefitGetAllProductBenefitsGet$Response(params?: ProductBenefitGetAllProductBenefitsGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<ProductBenefitModel>>> {
    return productBenefitGetAllProductBenefitsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productBenefitGetAllProductBenefitsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  productBenefitGetAllProductBenefitsGet(params?: ProductBenefitGetAllProductBenefitsGet$Params, context?: HttpContext): Observable<Array<ProductBenefitModel>> {
    return this.productBenefitGetAllProductBenefitsGet$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<Array<ProductBenefitModel>>): Array<ProductBenefitModel> => r.body)
    );
  }

  /** Path part for operation `productBenefitPost()` */
  static readonly ProductBenefitPostPath = '/ProductBenefit';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productBenefitPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  productBenefitPost$Response(params?: ProductBenefitPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<string>> {
    return productBenefitPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `productBenefitPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  productBenefitPost(params?: ProductBenefitPost$Params, context?: HttpContext): Observable<string> {
    return this.productBenefitPost$Response(params, context).pipe(
      map((r: MDIStrictHttpResponse<string>): string => r.body)
    );
  }

}
